import React, { useState, useEffect, useRef } from 'react';
import api from '../api';

// HRMS (single link) + ERP (location-wise dropdown). Links configured in admin Settings.
export default function QuickLinks() {
  const [links, setLinks] = useState({ hrms_url: null, erp_links: [] });
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => { api.get('/master/links').then(r => setLinks(r.data || {})).catch(()=>{}); }, []);
  useEffect(() => {
    const close = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('click', close); return () => document.removeEventListener('click', close);
  }, []);

  const erp = links.erp_links || [];
  if (!links.hrms_url && !erp.length) return null;

  return (
    <div className="flex-gap" style={{ gap:8 }}>
      {links.hrms_url && (
        <a className="btn btn-secondary btn-sm" style={{ textDecoration:'none' }} href={links.hrms_url} target="_blank" rel="noopener noreferrer">HRMS</a>
      )}
      {erp.length > 0 && (
        <div ref={ref} style={{ position:'relative' }}>
          <button className="btn btn-secondary btn-sm" onClick={() => setOpen(o => !o)}>ERP ▾</button>
          {open && (
            <div style={{ position:'absolute', right:0, top:'calc(100% + 4px)', minWidth:180, background:'var(--bg2)',
              border:'1px solid var(--border)', borderRadius:'var(--radius)', boxShadow:'0 4px 14px rgba(14,27,71,0.12)', zIndex:1200, padding:4 }}>
              {erp.map((l, i) => (
                <a key={i} href={l.url} target="_blank" rel="noopener noreferrer" onClick={() => setOpen(false)}
                  style={{ display:'block', padding:'8px 12px', fontSize:13, color:'var(--text)', borderRadius:6, textDecoration:'none' }}
                  onMouseEnter={e => e.currentTarget.style.background='var(--bg3)'}
                  onMouseLeave={e => e.currentTarget.style.background='transparent'}>
                  {l.label}
                </a>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
